import type { TooltipRenderProps } from "react-joyride"
import { Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { StandardButton } from "../buttons/StandardButton"

const useStyles = makeStyles()((theme) => ({
    root: {
        maxWidth: "24rem",
        padding: "1.5rem",
        borderRadius: ".75rem",
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[3],
    },
    headerTitle: {
        fontWeight: 600,
    },

    skipButton: {
        border: "none",
        padding: 0,
        backgroundColor: "transparent",
        color: theme.palette.text.secondary,
        cursor: "pointer",
        fontSize: ".875rem",
        textDecoration: "underline",
    },
}))

export function ProductTourTooltip(props: TooltipRenderProps) {
    const { classes } = useStyles()
    const { index, size, step, primaryProps, backProps, skipProps } = props

    return (
        <Stack gap="2rem" className={classes.root}>
            <Stack justifyContent="space-between" alignItems="center" gap="1rem" direction="row">
                <Typography variant="subtitle1" className={classes.headerTitle}>
                    {typeof step.title === "string" ? step.title : "Facilitynet tour"}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {index + 1} / {size}
                </Typography>
            </Stack>

            <Typography variant="body2">{step.content}</Typography>

            <Stack direction="row" justifyContent="space-between" alignItems="center" gap="1rem">
                {skipProps ? (
                    <button {...skipProps} className={classes.skipButton}>
                        {skipProps["aria-label"] ?? "Skip"}
                    </button>
                ) : (
                    <span />
                )}

                <Stack flexDirection="row" gap=".5rem">
                    {backProps ? (
                        <StandardButton {...backProps} variant="outlined" size="small" color="grey" fullWidth={false}>
                            {backProps["aria-label"] ?? "Back"}
                        </StandardButton>
                    ) : null}

                    <StandardButton {...primaryProps} variant="contained" size="small" fullWidth={false}>
                        {primaryProps["aria-label"] ?? "Next"}
                    </StandardButton>
                </Stack>
            </Stack>
        </Stack>
    )
}
